import { LogoIcon } from '@/components/icons';
import { ReactNode } from 'react';

type PopupShellProps = { children: ReactNode };

const PopupShell = ({ children }: PopupShellProps) => (
  <div className="bg-surface_l2 fixed inset-0 flex flex-col overflow-y-auto">
    <header className="px-lg py-md flex items-center">
      <LogoIcon className="h-[22px]" />
    </header>
    <main className="px-lg pb-xl mx-auto flex w-full max-w-md flex-1 flex-col">{children}</main>
  </div>
);

export default PopupShell;
